export default __webpack_public_path__ + "static/media/polygen-sidebar-logo.7365a4a9.svg";